// extracted by mini-css-extract-plugin
module.exports = {"removeLinkStyle":"Summary_removeLinkStyle__1mfeX","quotedBoundContainer":"Summary_quotedBoundContainer__39A6e","summaryDetailGrid":"Summary_summaryDetailGrid__lIopZ"};